import React,{useEffect} from 'react'
import eight from './imgg/eight.jpg'
import one from './imgg/two.jpg'
import three from './imgg/thirteen.jpg'
import four from './imgg/eleven.jpg'
import five from './imgg/five.png'
import './All.css'
import AOS from 'aos';
import 'aos/dist/aos.css'
import {
    Link
  } from "react-router-dom";

export default function All() {
    useEffect(() => {
        AOS.init({
          duration : 2000
        });
      }, []);
    return (
        <div>
            <div class="container">
                {/* <div class="hamburger-menu" onClick={displaysidebar}>
                    <div class="line line-1"></div>
                    <div class="line line-2"></div>
                    <div class="line line-3"></div>
                    <span>Close</span>
                </div> */}
                <header class="header">
                    <div class="img-wrapper">
                        
                    <img alt='' src={eight} />
                    </div>
                    <div class="banner">
                    <h1>TO FRO LOGISTICS</h1>
                    <p></p>
                    <Link to="/contact">
                            <button>CONTACT US</button>
                    </Link>
                    
                    </div>
                </header>

                <section class="sidebar">
                    <ul class="menu">
                    <li class="menu-item">
                        <a href="/" class="menu-link" data-content="Home">Home</a>
                    </li>
                    <li class="menu-item">
                        <a href="/" class="menu-link" data-content="About Us">About Us</a>
                    </li>
                    <li class="menu-item">
                    <Link to="/team">
                                <a href="/" class="menu-link" data-content="Team">Team</a>
                    </Link>
                        
                    </li>
                    <li class="menu-item">
                        <a href="/" class="menu-link" data-content="Pricing">Pricing</a>
                    </li>
                    <li class="menu-item">
                        <a href="/" class="menu-link" data-content="Contact">Contact</a>
                    </li>
                    </ul>
                    <div class="social-media">
                    <a href="/"><i class="fab fa-facebook-f"></i></a>
                    <a href="/"><i class="fab fa-instagram"></i></a>
                    <a href="/"><i class="fab fa-twitter"></i></a>
                    </div>
                </section>

                <section class="about-us" id='about'>
                    <div data-aos="fade-up" class="section-header">
                    <h1 class="section-heading">About Us</h1>
                    <div class="underline"></div>
                    </div>
                    <div class="services">
                    <div  data-aos="fade-up" class="service">
                        <div class="service-header">
                        <i class="fas fa-pen-nib"></i>
                        <h3>Knowledge</h3>
                        </div>
                        <p class="service-text">
                        Our robust knowledge of local terain puts us in advantage
                            position to offer you unmatched secondary distribution services
                        </p>
                    </div>
                    <div  data-aos="fade-up" class="service">
                        <div class="service-header">
                            <i class="fas fa-paint-roller"></i>
                            <h3>Experience</h3>
                        </div>
                        <p class="service-text">
                        Our experience and professional teams will facilitate
                            the modelling and execution of projects from commencemen
                            t to conclusion
                        </p>
                    </div>
                    <div  data-aos="fade-up" class="service">
                        <div  class="service-header">
                        <i class="fas fa-pencil-alt"></i>
                        <h3>Fast and Accurate</h3>
                        </div>
                        <p class="service-text">
                        At TO FRO Logistics, we are committed to providing smart and 
                        effective Logistics Solutions for every business.
                        With timed deliveries that offer complete flexibility
                        </p>
                    </div>
                    <div  data-aos="fade-up" class="service">
                        <div class="service-header">
                        <i class="fas fa-paint-brush"></i>
                        <h3>E-COMMERCE LOGISTICS</h3>
                        </div>
                        <p class="service-text">
                        We work in partnership with you to achieve the 
                        right delivery solutions that will convey 
                        positive outcomes to your e-Commerce business.
                        </p>
                    </div>
                    <div  data-aos="fade-up" class="service">
                        <div class="service-header">
                        <i class="fas fa-ruler-combined"></i>
                        <h3>Timely Delivery</h3>
                        </div>
                        <p class="service-text">
                        We are committed to providing cost effective Logistics solutions for every business in Nigeria.
                            With faster and technology powered delivery services, 
                            we offer complete flexibility that are timely and reliable.
                        </p>
                    </div>
                    <div data-aos="fade-up"  class="service">
                        <div class="service-header">
                        <i class="far fa-building"></i>
                        <h3>Safety and Protection</h3>
                        </div>
                        <p class="service-text">
                        To FRO will play a major role of packing your goods safely before they are transported.
                            We always pack the goods in different safety packages
                        to ensure that the goods arrive in good condition.
                        </p>
                    </div>
                    <div data-aos="fade-up"  class="about-us-img-wrapper">
                        <img alt='' src={five} />
                    </div>
                    </div>
                </section>

                <section class="team">
                    <div  data-aos="fade-up" class="section-header">
                    <h1 class="section-heading">Our Vehicles</h1>
                    <div class="underline"></div>
                    </div>
                    <div class="cards-wrapper">
                    <div  data-aos="fade-up" class="card">
                        <div class="card-img-wrapper">
                        <img src={three} alt="CEO" />
                        </div>
                        <div class="card-info">
                        <h2>Semi Trailer Trucks</h2>
                        <h3>Truck</h3>
                        
                        <Link to="/vehicles">
                            <button>Check More</button>
                        </Link>
                        
                        </div>
                    </div>
                    <div data-aos="fade-up"  class="card">
                        <div class="card-img-wrapper">
                        <img src={four} alt="Designer" />
                        </div>
                        <div class="card-info">
                        <h2>Straight Trucks</h2>
                        <h3>Truck</h3>
                        
                        <Link to="/vehicles">
                            <button>Check More</button>
                        </Link>
                        </div>
                    </div>
                    <div data-aos="fade-up" class="card">
                        <div class="card-img-wrapper">
                        <img src={one} alt="Architect" />
                        </div>
                        <div class="card-info">
                        <h2>Tail Lift Truck</h2>
                        <h3>Truck</h3>
                    
                        <Link to="/vehicles">
                            <button>Check More</button>
                        </Link>
                        </div>
                    </div>
                    </div>
                </section>
            </div>
        </div>
    )
}
